import { axios as service } from '../axiosService';
import { BASE_URL } from './index';

export const saveIntegrationRequest = ({ formData, projectId }) => {
  if (!projectId) {
    return {};
  }

  return service.post(
    `${BASE_URL}/project/integrationModuleWithTab/${projectId}`,
    formData,
  );
};

export const getIntergrationOverview = async (projectId) =>
  await service.get(
    `${BASE_URL}/project/integrationModuleWithTab/${projectId}?displayAll=true`,
  );
